import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, WrapperElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type WrapperProps = RecursivePartial<WrapperElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | WrapperElement["children"];
  data?: WrapperElement["data"];
};

export function Wrapper(props: WrapperProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: WrapperElement = {
    type: BasicType.WRAPPER,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
